<template>
  <transition name="form">
    <form
      class="chat-form"
      v-on:submit.prevent="formSubmit"
      :class="formClasses"
    >
      <input
        type="text"
        class="input"
        name="answer"
        v-model="answerChat"
        autocomplete="off"
        @focus="focus = true"
        @blur="focus = false"
        placeholder="Typ hier je antwoord.."
      />
      <button
        type="submit"
        class="submit"
      >
        <SubmitIcon class="submit-icon"></SubmitIcon>
      </button>
    </form>
  </transition>
</template>

<script>
import { SubmitIcon } from '@/components/icons'

export default {
  name: 'ChatForm',
  data () {
    return {
      answerChat: '',
      focus: false
    }
  },
  components: {
    SubmitIcon
  },
  methods: {
    formSubmit () {
      this.$emit('formSubmit')
      this.answerChat = ''
    }
  },
  computed: {
    formClasses () {
      return {
        'is-focus': this.focus,
        'is-not-focus': !this.focus
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-form {
  position: relative;
  transition: all .4s ease .4s;
}
@keyframes flicker {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
.is-not-focus:before {
  content: '';
  position: absolute;
  animation: 1s flicker steps(1) infinite;
  background-color: #5667C6;
  height: 27px;
  width: 2px;
  left: 22px;
  top: 14px;
}
.submit {
  padding: 0;
  border-radius: 0;
  box-shadow: none;
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
  border: none;
  background: none;
  outline: 0;
  font-size: 0;
  cursor: pointer;
}
.submit-icon {
  cursor: pointer;
}
.input {
  background-color: white;
  border: none;
  width: 100%;
  line-height: 1;
  color: #5667C6;
  font-size: 18px;
  border-radius: 27.5px;
  height: 55px;
  outline: 0;
  padding: 0 27px;
}
.form-enter {
  opacity: 0;
}
.form-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatForm.vue